import React, { useState } from 'react';
import { SignificationConfig } from '../../../../types/signification.types';
import './StimulusScreen.css';

interface StimulusScreenProps {
  config: SignificationConfig;
  onContinue: () => void;
}

/**
 * Pulse stimulus screen — displays material (image/video/text)
 * to the participant before signification begins.
 */
export const StimulusScreen: React.FC<StimulusScreenProps> = ({ config, onContinue }) => {
  const stimulus = config.stimulus;
  const [imageLoaded, setImageLoaded] = useState(false);

  if (!stimulus) return null;

  return (
    <div className="stim-container">
      <div className="stim-badge">PULSE</div>
      <div className="stim-label">STIMULUS</div>

      <div className="stim-caption">{stimulus.caption}</div>

      <div className="stim-content">
        {stimulus.type === 'image' && stimulus.url && (
          <div className="stim-image-wrap">
            <img
              src={stimulus.url}
              alt={stimulus.caption}
              className={`stim-image ${imageLoaded ? 'stim-image--loaded' : ''}`}
              onLoad={() => setImageLoaded(true)}
            />
            {!imageLoaded && <div className="stim-image-placeholder" />}
          </div>
        )}

        {stimulus.type === 'video' && stimulus.url && (
          <div className="stim-video-wrap">
            <video
              src={stimulus.url}
              controls
              playsInline
              className="stim-video"
            />
          </div>
        )}

        {stimulus.type === 'text' && stimulus.content && (
          <div className="stim-text-wrap">
            <p className="stim-text">{stimulus.content}</p>
          </div>
        )}
      </div>

      <div className="stim-instruction">
        After viewing this, you will share your reaction by placing yourself in the space below.
      </div>

      <div className="stim-actions">
        <button className="stim-continue-btn" onClick={onContinue}>
          Continue to respond
        </button>
      </div>
    </div>
  );
};
